import { render, staticRenderFns } from "./SportsGames.vue?vue&type=template&id=63300fb9&"
import script from "./SportsGames.vue?vue&type=script&lang=js&"
export * from "./SportsGames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports